<template>
  <div>
    <div class="card shadow mb-4">
      <div class="card-header py-3">
        <span class="m-0 font-weight-bold text-primary">Order List</span>
      </div>
      <div class="card-body">
        <div class="card-body">
          <b-tabs content-class="mt-3">
            <b-tab title="Assign For Delivery" active>
              <div class="table-responsive card-body">
                <table
                  class="table table-bordered"
                  id="dataTable1"
                  width="100%"
                  cellspacing="0"
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Date & Time</th>
                      <th>Customer Name</th>
                      <th>Products</th>
                      <th>Amount</th>
                      <th>Payment</th>
                      <th>Packing</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(order, index) in getOrderByStatus(2)"
                      :key="index"
                    >
                      <td>{{ ++index }}</td>
                      <td>
                        {{
                          new Date(order.createdAt * 1000).toLocaleDateString(
                            "en-us",
                            {
                              month: "short",
                              day: "numeric",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit"
                            }
                          )
                        }}
                      </td>
                      <td>{{ getCustomer(order.customerId, "name") }}</td>
                      <td>
                        <b-btn
                          v-b-toggle="'packing' + order.createdAt"
                          class="form-control btn btn-warning"
                        >
                          Bucket
                        </b-btn>
                        <b-collapse
                          v-bind:id="'packing' + order.createdAt"
                          visible
                          class="pt-2"
                        >
                          <table class="table">
                            <thead>
                              <th>#</th>
                              <th>Name</th>
                              <th>Qty</th>
                              <th>Price</th>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(buck, buckindex) in getBucket(
                                  order.bucketId,
                                  'all'
                                ).product"
                                :key="buckindex"
                              >
                                <td>{{ ++buckindex }}</td>
                                <td>
                                  {{ getProduct(buck.productId, "name") }}
                                </td>
                                <td>
                                  {{ buck.qty }}
                                </td>
                                <td>{{ buck.price }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </b-collapse>
                      </td>
                      <td>{{ getBucket(order.bucketId, "total") }}</td>
                      <td>{{ order.payment.type }}</td>
                      <td>
                        <span v-if="order.deliveryStatus == false">
                          <button
                            class="btn btn-primary"
                            @click="ChanceStatus('delivery', order.id)"
                          >
                            Going for Delivery
                          </button>
                        </span>
                        <span v-else>
                          <button
                            class="btn btn-success"
                            @click="Delivered(order)"
                          >
                            Delivered
                          </button>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>
            <b-tab title="Available For Delivery">
              <div class="table-responsive card-body">
                <table
                  class="table table-bordered"
                  id="dataTable1"
                  width="100%"
                  cellspacing="0"
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Date & Time</th>
                      <th>Customer Name</th>
                      <th>Products</th>
                      <th>Amount</th>
                      <th>Payment</th>
                      <th>Packing</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(order, index) in getfullOrderByStatus(
                        1,
                        'packStatus',
                        true
                      )"
                      :key="index"
                    >
                      <td>{{ ++index }}</td>
                      <td>
                        {{
                          new Date(order.createdAt * 1000).toLocaleDateString(
                            "en-us",
                            {
                              month: "short",
                              day: "numeric",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit"
                            }
                          )
                        }}
                      </td>
                      <td>{{ getCustomer(order.customerId, "name") }}</td>
                      <td>
                        <b-btn
                          v-b-toggle="'packing' + order.createdAt"
                          class="form-control btn btn-warning"
                        >
                          Bucket
                        </b-btn>
                        <b-collapse
                          v-bind:id="'packing' + order.createdAt"
                          class="pt-2"
                        >
                          <table class="table">
                            <thead>
                              <th>#</th>
                              <th>Name</th>
                              <th>Qty</th>
                              <th>Price</th>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(buck, buckindex) in getBucket(
                                  order.bucketId,
                                  'all'
                                ).product"
                                :key="buckindex"
                              >
                                <td>{{ ++buckindex }}</td>
                                <td>
                                  {{ getProduct(buck.productId, "name") }}
                                </td>
                                <td>
                                  {{ buck.qty }}
                                </td>
                                <td>{{ buck.price }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </b-collapse>
                      </td>
                      <td>{{ getBucket(order.bucketId, "total") }}</td>
                      <td>{{ order.payment.type }}</td>
                      <td>
                        <button
                          class="btn btn-success"
                          @click="AssignOrder(order)"
                        >
                          Assign Self <i class="fa fa-check"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const $ = window.$;
import { dbFs } from "@/modules/database";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      dataTable: null,
      customers: [],
      products: [],
      buckets: [],
      fullorders: [],
      vendors: [],
      loading: false,
      orders: []
    };
  },
  mounted() {
    this.setupFirebaseReading();
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
  methods: {
    setupFirebaseReading: function() {
      this.loading = true;
      if (this.user) {
        this.$bind(
          "orders",
          dbFs.collection("order").where("delivery", "==", this.user.uid)
        )
          .catch(error => {
            this.loading = false;
            console.log(error);
          })
          .finally(() => {
            this.getCustomersData();
            this.getProductsData();
            this.getVendorsData();
            this.getBucketData();
            this.getFullOrder();
            this.loading = false;
            this.forDataTable();
          });
      }
    },
    getCustomersData() {
      this.loading = true;
      this.$bind("customers", dbFs.collection("customer"))
        .catch(error => {
          this.loading = false;
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCustomer(id, dataType) {
      let personalDetails = {
        name: "Not Available",
        number: "Not found",
        email: ""
      };
      for (const cusKey of Object.keys(this.customers)) {
        const customer = this.customers[cusKey];
        if (id == customer.id) {
          personalDetails = customer;
        }
      }
      if (dataType == "name") {
        return personalDetails.name + " \n " + personalDetails.number;
      }
      if (dataType == "email") {
        return personalDetails.email;
      } else {
        return personalDetails.number;
      }
    },
    AssignOrder(order) {
      let id = order.id;
      let delivery = this.user.uid;
      let deliveryStatus = false;
      let value = 2;
      let status = order.status;
      status.push({
        createdAt: Math.round(+new Date() / 1000),
        type: value,
        updateBy: this.user.uid
      });
      dbFs
        .collection("order")
        .doc(id)
        .update({
          status: status,
          delivery: delivery,
          deliveryStatus: deliveryStatus
        });
    },
    getFullOrder() {
      this.loading = true;
      this.$bind("fullorders", dbFs.collection("order"))
        .catch(error => {
          this.loading = false;
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProductsData() {
      this.loading = true;
      this.$bind("products", dbFs.collection("products"))
        .catch(error => {
          console.log(error);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getBucketData() {
      this.loading = true;
      this.$bind("buckets", dbFs.collection("bucket"))
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProduct(id, dataType) {
      let productDetails = {
        name: "Not Found",
        unitType: "",
        image: ""
      };
      for (const cusKey of Object.keys(this.products)) {
        const product = this.products[cusKey];
        if (id == product.id) {
          productDetails = product;
        }
      }
      if (dataType == "name") {
        return productDetails.name;
      }
      if (dataType == "unitType") {
        return productDetails.unitType;
      }
      if (dataType == "image") {
        return productDetails.image;
      }
    },
    getVendorsData() {
      this.loading = true;
      this.$bind("vendors", dbFs.collection("vendor"))
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getVendor(id, dataType) {
      let VendorDetails = {
        shopDetails: {
          name: "Not Found",
          address: {
            firstLine: "",
            city: "",
            state: "",
            pincode: ""
          }
        },
        personalDetails: {
          name: "Not Found"
        }
      };
      for (const cusKey of Object.keys(this.vendors)) {
        const vendor = this.vendors[cusKey];
        if (id == vendor.id) {
          VendorDetails = vendor;
        }
      }
      if (dataType == "shopname") {
        return VendorDetails.shopDetails.name;
      }
      if (dataType == "ownername") {
        return VendorDetails.personalDetails.name;
      }
      if (dataType == "address") {
        let address = `${VendorDetails.shopDetails.address.firstLine},
        ${VendorDetails.shopDetails.address.city},
        ${VendorDetails.shopDetails.address.state},
        ${VendorDetails.shopDetails.address.pincode}`;
        return address;
      }
    },
    getBucket(id, dataType) {
      let bucketData = {};
      for (const cusKey of Object.keys(this.buckets)) {
        const bucket = this.buckets[cusKey];
        if (id == bucket.id) {
          bucketData = bucket;
        }
      }
      if (dataType == "all") {
        return bucketData;
      }
      if (dataType == "total") {
        let total = 0;
        if (bucketData.product) {
          for (const buck of bucketData.product) {
            let amount = buck.price;
            total += amount + 50;
          }
        }
        return total;
      }
    },
    getLastOrderStatus(status) {
      let lastarr = status.slice(-1)[0];
      return [lastarr];
    },
    checkOrderStatus(status, checkstatus) {
      let currstatus = [];
      if (status.length != 1) {
        let lastarr = status.slice(-1)[0];
        currstatus = [lastarr];
      } else {
        currstatus = status;
      }
      for (let index = 0; index < currstatus.length; index++) {
        if (currstatus[index].type == checkstatus) {
          return true;
        }
      }
    },
    forDataTable() {
      this.dataTable = $("#dataTable").DataTable({
        lengthMenu: [10, 20]
      });
    },
    ChanceStatus(type, id) {
      if (type == "delivery")
        dbFs
          .collection("order")
          .doc(id)
          .update({
            deliveryStatus: true
          })
          .catch(error => {
            console.log(error);
          });
    },
    Delivered(order) {
      let status = order.status;
      status.push({
        createdAt: Math.round(+new Date() / 1000),
        type: 3,
        updateBy: this.user.uid
      });
      console.log(status);
      dbFs
        .collection("order")
        .doc(order.id)
        .update({
          status: status
        })
        .catch(error => {
          console.log(error);
        });
    },
    getOrderByStatus(type) {
      let status = "";
      let newOrderList = [];
      this.orders.forEach(order => {
        status = this.getLastOrderStatus(order.status);
        if (status[0].type == type) {
          newOrderList.push(order);
        }
      });
      return newOrderList;
    },
    getfullOrderByStatus(type, current = "", asper = "") {
      let status = "";
      let newOrderList = [];
      this.fullorders.forEach(order => {
        status = this.getLastOrderStatus(order.status);
        if (status[0].type == type) {
          switch (current) {
            case "packStatus":
              if (order.packStatus == asper) {
                newOrderList.push(order);
              }
              break;
            case "deliveryStatus":
              if (order.deliveryStatus == asper) {
                newOrderList.push(order);
              }
              break;
            default:
              newOrderList.push(order);
              break;
          }
        }
      });
      return newOrderList;
    }
  }
};
</script>

<style scoped>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>
